/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { FormatIcu } from '@tolgee/format-icu'
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react'

const { VITE_APP__TOLGEE_API_KEY, VITE_APP__TOLGEE_CDN } = import.meta.env
const missingTolgeeEnvVars = [
  !VITE_APP__TOLGEE_API_KEY && 'VITE_APP__TOLGEE_API_KEY',
  !VITE_APP__TOLGEE_CDN && 'VITE_APP__TOLGEE_CDN',
].filter(Boolean)

if (missingTolgeeEnvVars.length > 0) {
  throw new Error(
    `Missing required Tolgee environment variable(s): ${missingTolgeeEnvVars.join(', ')}`,
  )
}

export const tolgee = Tolgee()
  .use(DevTools())
  .use(
    BackendFetch({
      prefix: VITE_APP__TOLGEE_CDN,
    }),
  )
  .use(FormatIcu())
  .init({
    language: 'en',
    defaultLanguage: 'en',
    fallbackLanguage: 'en',
    apiUrl: 'https://app.tolgee.io',
    apiKey: VITE_APP__TOLGEE_API_KEY,
  })
